// directives imports
import { SwAutofocusDirective } from './sw-autofocus';
import { SwHrefDirective } from './sw-href';
import { SwImgFallbackDirective } from './sw-img-fallback';
import { SwSetFocusDirective } from './sw-set-focus';

export const directives: any[] = [
  // directives export
  SwAutofocusDirective,
  SwHrefDirective,
  SwImgFallbackDirective,
  SwSetFocusDirective,
];
